import { useState } from "react";

interface FilterPanelProps {
  genres: string[];
  regions: string[];
  years: number[];
  genre: string;
  region: string;
  year: string;
  status: string;
  sort: string;
  onGenre: (v: string) => void;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onStatus: (v: string) => void;
  onSort: (v: string) => void;
}

const statusOptions = [
  { value: "all", label: "全部" },
  { value: "now", label: "正在热映" },
  { value: "upcoming", label: "即将上映" },
];

const sortOptions = [
  { value: "release", label: "上映时间" },
  { value: "rating", label: "评分" },
  { value: "heat", label: "热度" },
];

export default function FilterPanel(props: FilterPanelProps) {
  const [open, setOpen] = useState(false);

  const chipClass = (active: boolean) =>
    `whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
      active
        ? "bg-primary-500 text-background-50"
        : "border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
    }`;

  const groups = (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <span className="w-14 shrink-0 text-sm text-foreground-500">类型</span>
        {["全部", ...props.genres].map((g) => (
          <button key={g} type="button" onClick={() => props.onGenre(g)} className={chipClass(props.genre === g)}>
            {g}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="w-14 shrink-0 text-sm text-foreground-500">地区</span>
        {["全部", ...props.regions].map((r) => (
          <button key={r} type="button" onClick={() => props.onRegion(r)} className={chipClass(props.region === r)}>
            {r}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="w-14 shrink-0 text-sm text-foreground-500">年份</span>
        {["全部", ...props.years.map(String)].map((y) => (
          <button key={y} type="button" onClick={() => props.onYear(y)} className={chipClass(props.year === y)}>
            {y}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="w-14 shrink-0 text-sm text-foreground-500">状态</span>
        {statusOptions.map((s) => (
          <button key={s.value} type="button" onClick={() => props.onStatus(s.value)} className={chipClass(props.status === s.value)}>
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-filter-3-line text-accent-600"></i>
          筛选条件
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden text-sm text-foreground-500 sm:inline">排序</span>
          <div className="flex rounded-full bg-background-100 p-1">
            {sortOptions.map((s) => (
              <button
                key={s.value}
                type="button"
                onClick={() => props.onSort(s.value)}
                className={`whitespace-nowrap rounded-full px-3 py-1 text-sm transition-colors ${
                  props.sort === s.value
                    ? "bg-background-50 text-primary-600"
                    : "text-foreground-500 hover:text-foreground-800"
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex items-center gap-1 rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 md:hidden"
          >
            {open ? "收起" : "展开"}
            <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
          </button>
        </div>
      </div>
      <div className={`${open ? "mt-4 block" : "hidden"} md:mt-4 md:block`}>{groups}</div>
    </div>
  );
}